export interface SupportIconOption {
  value: string;
  primeIcon: string;
  label: string;
}

/**
 * Catálogo canónico de íconos de categorías de soporte.
 * El valor se guarda en support_category.icon y la app mobile lo mapea
 * a iconsax en src/components/Support/supportCategoryIcons.ts — mantener sincronizados.
 */
export const SUPPORT_ICON_OPTIONS: SupportIconOption[] = [
  { value: "sun", primeIcon: "pi pi-sun", label: "Clima" },
  { value: "card", primeIcon: "pi pi-credit-card", label: "Pagos" },
  { value: "book", primeIcon: "pi pi-book", label: "Reglamento" },
  { value: "forbidden", primeIcon: "pi pi-ban", label: "Cancelaciones" },
  { value: "map", primeIcon: "pi pi-map", label: "Logística" },
  { value: "calendar", primeIcon: "pi pi-calendar", label: "Eventos" },
  { value: "location", primeIcon: "pi pi-map-marker", label: "Sedes" },
  { value: "shield", primeIcon: "pi pi-shield", label: "Seguridad" },
  { value: "user", primeIcon: "pi pi-user", label: "Cuenta" },
  { value: "wallet", primeIcon: "pi pi-wallet", label: "Reembolsos" },
  { value: "chat", primeIcon: "pi pi-comments", label: "Comunidad" },
  { value: "question", primeIcon: "pi pi-question-circle", label: "General" },
  { value: "clock", primeIcon: "pi pi-clock", label: "Horarios" },
  { value: "star", primeIcon: "pi pi-star", label: "Destacados" },
  { value: "gift", primeIcon: "pi pi-gift", label: "Beneficios" },
  { value: "ticket", primeIcon: "pi pi-ticket", label: "Entradas" },
  { value: "bell", primeIcon: "pi pi-bell", label: "Notificaciones" },
  { value: "phone", primeIcon: "pi pi-phone", label: "Contacto" },
  { value: "lock", primeIcon: "pi pi-lock", label: "Privacidad" },
  { value: "info", primeIcon: "pi pi-info-circle", label: "Información" },
  { value: "settings", primeIcon: "pi pi-cog", label: "Configuración" },
  { value: "heart", primeIcon: "pi pi-heart", label: "Salud" },
  { value: "home", primeIcon: "pi pi-home", label: "Instalaciones" },
  { value: "team", primeIcon: "pi pi-users", label: "Equipos" },
  { value: "email", primeIcon: "pi pi-envelope", label: "Email" },
  { value: "warning", primeIcon: "pi pi-exclamation-triangle", label: "Incidentes" },
  { value: "globe", primeIcon: "pi pi-globe", label: "Internacional" },
  { value: "truck", primeIcon: "pi pi-truck", label: "Traslados" },
];

export const getSupportIconOption = (
  value: string | null | undefined
): SupportIconOption | undefined =>
  SUPPORT_ICON_OPTIONS.find((option) => option.value === value);
